import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const User20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 1C7.43517 1 5.5 2.93517 5.5 5.25C5.5 7.56483 7.43517 9.5 9.75 9.5C12.0648 9.5 14 7.56483 14 5.25C14 2.93517 12.0648 1 9.75 1ZM9.75 2.5C11.2478 2.5 12.5 3.75217 12.5 5.25C12.5 6.74783 11.2478 8 9.75 8C8.25217 8 7 6.74783 7 5.25C7 3.75217 8.25217 2.5 9.75 2.5Z'
      fill='currentColor'
    />
    <path
      d='M2.5 15.75C2.5 13.9551 3.95507 12.5 5.75 12.5H13.75C15.5449 12.5 17 13.9551 17 15.75V18.75H18.5V15.75C18.5 13.1266 16.3734 11 13.75 11H5.75C3.12665 11 1 13.1266 1 15.75V18.75H2.5V15.75Z'
      fill='currentColor'
    />
  </Svg>
);

User20.displayName = 'User20';
export default User20;
